import { urls } from "../urls";
import { membershipSettingUrls } from "../MemberService/urls";
const bookingService = urls.developmentUrl + ':5005/'
//const bookingService = "https://fb48-41-84-135-252.ngrok.io/";
const mpesaService = urls.developmentUrl + ":5039/";

export const paymentMethodUrls = {
	postPaymentMethod: bookingService + "payments/methods/new",
	getPaymentMethods: bookingService + "payments/methods/view",
	getPaymentMethod: bookingService + "starts/single/",
	deletePaymentMethod: bookingService + "payments/methods/delete",
	editPaymentMethod: bookingService + "payments/default/moduify",
	getAllPaymentMethods: bookingService + "payments/methods/view",
	restorePaymentMethod: bookingService + "starts/restore/",
	getDeletedPaymentMethod: bookingService + "payments/default/delete",
	getAllCreditCardAccounts: bookingService + "payments/gateways/view",
	fetchPaymentGateways: bookingService + "payments/gateways/view",
	postPaymentGateways: bookingService + "payments/gateways/new",
	updatePaymentGateways: bookingService + "payments/gateways/modify",
	getMpesaTransactions: mpesaService + "mpesa/transactions"
};

export const bookingTypeUrls = {
	postBookingType: bookingService + "bookings/types/new",
	getPublicBookingTypes: bookingService + "bookings/public/types/view",
	getBackBookingTypes: bookingService + "bookings/back/types/view",
	getBookingTypes: bookingService + "bookings/types/view",
	getBookingType: bookingService + "bookings/types/view/",
	deleteBookingType: bookingService + "bookings/types/delete",
	editBookingType: bookingService + "bookings/types/modify",
	getAllBookingTypes: bookingService + "bookings/types/view",
	restoreBookingType: bookingService + "starts/restore/",
	getDeletedBookingType: bookingService + "starts/deleted"
};

export const bookingUrls = {
	generateReports: bookingService + "generate/reports/csv",
	fetchGateEntryReport: bookingService + "reports/gate-entry/today",
	fetchDailyReport: bookingService + "reports/details/today",
	fetchBookingVolumeReport: bookingService + "reports/summary",
	inventoryBookingSchedule: bookingService + "bookings/inventory/view/schedule",
	facilityBookingSchedule: bookingService + "bookings/facility/view/schedule",
	pendingPartnerBookings: bookingService + "partners/bookings/view/pending",
	pendingGroupBookings: bookingService + "group/bookings/view/pending",
	postPayment: bookingService + "bookings/payment/new",
	allocateReceipt: bookingService + "bookings/bankslip/allocate",
	postGroupBooking: bookingService + "group/bookings/new",
	updateGroupBooking: bookingService + "group/bookings/modify",
	postPartnerBooking: bookingService + "partners/bookings/new",
	modifyPartnerBooking: bookingService + "partners/bookings/modify",
	postExpressBooking: bookingService + "bookings/express/new",
	postBooking: bookingService + "bookings/new",
	postIveriBooking: bookingService + "iveri-donation/new",
	getCheckedInBookings: bookingService + "bookings/view/checked_in",
	checkInventoryAvailability:
		bookingService + "bookings/inventory/view/by_id_date",
	checkFacilityAvailability:
		bookingService + "bookings/facility/available/date",
	checkFacilityPublicAvailability:
		bookingService + "bookings/public/facility/available/date",

	checkExternalFacilityAvailability:
		bookingService + "bookings/external-facility/available/date",

	checkExternalFacilityPublicAvailability:
		bookingService + "bookings/public/external-facility/available/date",

	checkSingleFacilityAvailability:
		bookingService + "bookings/single-facility/available/date",
	getCheckedOutBookings: bookingService + "bookings/view/checked_out",
	getConfirmedBookings: bookingService + "bookings/view/confirmed",
	getUnConfirmedBookings: bookingService + "bookings/view/unconfirmed",
	confirmBooking: bookingService + "bookings/confirm",
	checkInBooking: bookingService + "bookings/check_in",
	checkOutBooking: bookingService + "bookings/check_out",
	reprintReceipt: bookingService + "print/receipt",
	getBookings: bookingService + "bookings/view",
	getBooking: bookingService + "bookings/view/",
	getBookingViewDetail: bookingService + "bookings/view-detail/",
	getBookingViewMoreDetail: bookingService + "bookings/view-more-details/",
	getBookingCheckin: bookingService + "bookings/view-checkin/",
	getBookingPayment: bookingService + "bookings/view/payment/",
	getSingleBookingTotalCost: bookingService + "booking/total-cost/",
	getBookingTickets: bookingService + "tickets/view",
	getBookingPasses: bookingService + "passes/view",
	deleteBooking: bookingService + "bookings/delete",
	editBooking: bookingService + "bookings/modify",
	postponeBooking: bookingService + "bookings/postpone",
	postponePartnertBooking: bookingService + "bookings/partner_postpone",
	getAllBookings: bookingService + "bookings/view",
	getCurrentDayBookings: bookingService + "bookings/view/current_day",
	getAllStreamedBookings: bookingService + "bookings/view",
	getAllStreamedBookingsReport: bookingService + "bookings/view/report",
	getAllPartnerBookings: bookingService + "partners/bookings/view",
	getMyBookings: bookingService + 'guests/bookings/my-bookings/',
	getPartnerBookings: bookingService + "partners/bookings/view/partner/",
	getPartnerCheckinTodayBookings:
		bookingService + "partners/bookings/view/partner/",
	getPartnerCheckoutTodayBookings:
		bookingService + "partners/bookings/view/partner/",
	getCheckInToday: bookingService + "bookings/view/check_in/today",
	getInspectionBookingsToday: bookingService + "bookings/view/inspection",
	getAlertedBooking: bookingService + "bookings/view/inpected-alerted",
	getBookingResidencyProof: bookingService + "bookings/residency-proofs",
	getUnticketedAlertedBooking: bookingService + "bookings/view/inpected-unticketed-alerted",

	getInspectionBooking: bookingService + "bookings/inspection/view/",
	getCheckOutToday: bookingService + "bookings/view/check_out/today",
	getOverStaysThisMonth: bookingService + "bookings/view/overstays",
	restoreBooking: bookingService + "starts/restore/",
	mpesaRequest: bookingService + "bookings/payment/mpesa/new",

	bankSlipRequest: bookingService + "bookings/bankslip/new",

	paymentFailureRequest: bookingService + "bookings/payment/failure/",
	getPaymentFailureRequest: bookingService + "bookings/payment/failure",
	getBookingPayments: bookingService + "bookings/payments",
	requestEmailPaymentReminder: bookingService + "reminders/",
	getDeletedBooking: bookingService + "starts/deleted",
	generateCustomReport: bookingService + "filtered/report",
	generateFormatReport: bookingService + "filtered/report/formatted",
	generateCustomPartnerReport: bookingService + "filtered/report/partner",
	deferPayment: bookingService + "bookings/payment/defer",
	reinstateBooking: bookingService + "bookings/reinstate",
	getBatchFileData: bookingService + "batchfiles/view",
	generateBatchfile: bookingService + "batchfile/post",
	generateBnlBatchfile: bookingService + "batchfile/post/bnl",
	generateCreditNoteBatchfile: bookingService + "credit-notes/batchfile",
	generateBatchfileByDate: bookingService + "batchfile/post/by/date",
	fetchPaymentGateways: bookingService + "payments/gateways/view",
	postPaymentGateways: bookingService + "payments/gateways/new",
	printReceiptURl: bookingService + "print/invoice",
	printReceiptURlNew: bookingService + "print/invoice/new",
	printCreditNote: bookingService + "print/booking_credit_note_new",
	markAsFOC: bookingService + "bookings/compliments",
  markAsPAID: bookingService + "bookings/paid",
  markAsCONFIRMED: bookingService + "bookings/confirmed",
	sendBookingEmail: bookingService + "email/invoice",
	addNewSchool: bookingService + "schools/new",
	fetchAllSchools: bookingService + "schools/view",
	updateSchool: bookingService + "schools/modify",
	deleteSchool: bookingService + "schools/delete",
	removeBookedAccommodation: bookingService + "bookings/facility/delete",
	removeBookedActivity: bookingService + "bookings/inventory/delete",
	updateBookedCampsite: bookingService + "bookings/campsite/edit",
	issueCreditNote: bookingService + "credit-note/new",
	updateActivityDate: bookingService + "bookings/inventory/modify/date",
	updateAccommodationDates: bookingService + "bookings/facility/modify/date",
	updateCateringType: bookingService + "bookings/pelican/modify/catering",
	getActiveActivitiesBookings:bookingService + "booking/active_inventory",
	postBookingsBan:bookingService + "bookings/ban/new",
	getAllBookingsBan:bookingService + "bookings/ban/view",
	getBookingBan:bookingService + "bookings/ban/view/",
	updateBookingBan:bookingService + "bookings/ban/modify",
	searchBookingBan:bookingService + "bookings/ban/search/by_key",

	getPUserBookings: bookingService + "puser-bookings/view/",
	getFinanceStatements: bookingService + "user/statements/",
	getAllBookingUsers: bookingService + "booking_users",
	getAllBankSlipData: bookingService + "bookings/bankslip/view",

    getBookingDetailsByEmail: bookingService + "booking-details/by-email/",

	verifyWorkPermit: bookingService + "work-permit/verify",
    verifyWorkPermitBase64: bookingService + "work-permit/verify-base64",

    verifyPassport: bookingService + "passport/verify",
    verifyPassportBase64: bookingService + "passport/verify-base64",

	verifyDocumentViaQrCode: bookingService + "verify-document-qr",

	verifyKenyanId: bookingService + "kenyan-id/verify",
    verifyKenyanIdBase64: bookingService + "kenyan-id/verify-base64",
  logImageView: bookingService + "bookings/verification-image-viewed"
};

export const bookingSearchUrls = {
	searchByKey: bookingService + "bookings/search/by_key",
	searchByKeyReport: bookingService + "bookings/search/by_key/report",
	searchByKeyInspect: bookingService + "bookings/search/by_key/inspect",
	searchByKeyPartner: bookingService + "bookings/search/partner/by_key",
	searchBySingleDate: bookingService + "bookings/search/by_date/single",
	searchCheckInByDateRange: bookingService + "bookings/search/by_date/range",
	searchCheckInByDateRangeReport: bookingService + "bookings/search-report/by_date/range",
	searchPartnerCheckInByDateRange:
		bookingService + "bookings/search/by_date/partner/range",

	searchCheckOutByDateRange:
		bookingService + "bookings/search/by_date/range/check_out",
	searchByDateRange:
		bookingService + "bookings/search/by_date/range/check_in_out",

	searchInspectedAlertedBookings: bookingService + "bookings/search/alerted_bookings",
	searchUnticketedAlertedBookings: bookingService + "bookings/search/unticketed_alerted_bookings",
	searchProofedBookings: bookingService + "bookings/search/proofed_bookings",
	searchPaymentsByKey: bookingService + "bookings-payments/search/by_key",
	searchPaymentsByDateRange: bookingService + "bookings-payments/search/by_date/range",
	
	searchBankSlipByKey: bookingService + "bookings-bankslip/search/by_key",
	searchBankSlipByDateRange: bookingService + "bookings-bankslip/search/by_date/range",
};

export const conservationFeesUrls = {
	postConservationFee: bookingService + "payments/default/new",
	getConservationFees: bookingService + "payments/default/view",
	getFullConservationFees: bookingService + "payments/default/view",
	getConservationFee: bookingService + "starts/single/",
	deleteConservationFee: bookingService + "payments/default/delete",
	editConservationFee: bookingService + "payments/default/modify",
	getAllConservationFees: bookingService + "payments/default/view/public",
	getPublicConservationFeeByCheckIn:
		bookingService + "payments/public/check-in-date",
	getPublicConservationFeeByCheckInOut:
		bookingService + "payments/public/check-in-out-date",
	getAllScheduledConservationFees: bookingService + "payments/entry_fees",
	getAllScheduledSchoolConservationFees:
		bookingService + "payments/entry_fees/school",
	getSchoolConservationFees: bookingService + "payments/default/view/school",
	restoreConservationFee: bookingService + "starts/restore/",
	getDeletedConservationFee: bookingService + "starts/deleted",
	getFullConservationSchedule: bookingService + "payments/schedule/view",
	postConservationFeeSchedule: bookingService + "payments/schedule/new",
	ModifyConservationSchedule: bookingService + "payments/schedule/modify",
	ModifyConservationSchedulePricing:
		bookingService + "payments/schedule/item/modify",
	DeleteConservationSchedule: bookingService + "payments/schedule/delete",
	DeleteProofResidency: bookingService + "residency-proof/delete",
	getProofOfResidency: bookingService + "booking/residency-proof",

	getBnlCategories: bookingService + "payments/bnl/categories",
    getBnlSchedules: bookingService + "payments/bnl/schedules",
    postBnlSchedule: bookingService + "payments/bnl/schedules",
	disableBnlSchedule: bookingService + "payments/bnl/schedules/disable",
    postBnlPrice: bookingService + "payments/bnl/prices"

};

export const gatePassUrls = {
	payGatePass: bookingService + "gatepass/payments/new",
	postGatePass: bookingService + "gatepass/new",
	postGatePassMember: bookingService + "gatepass/members/new",
	getGatePasses: bookingService + "gatepass/view",
	getGatePass: bookingService + "gatepass/view/",
	getAllGatePasses: bookingService + "gatepass/view"
};

export const calendarUrls = {
	getCalendar: bookingService + "calendar/view",
	getCalendarInventory: bookingService + "calendar/view/inventory",
	getCalendarFacility: bookingService + "calendar/view/facility",
	getCalendarExernalFacility: bookingService + "calendar/view/external-facility",
	getCalendarCampSitesFacility: bookingService + "calendar/view/camping-sites",

	getPartnerCalendar: bookingService + "calendar/view/partner",
	getFacilityBookings: bookingService + "bookings/facility/list",
	getInventoryBookings: bookingService + "bookings/inventory/list",
	getInventoryPartnerBookings:
		bookingService + "bookings/inventory/partner/list",
	getConservationVehicles: bookingService + "calendar/entry/view",
	getPartnerConservationVehicles:
		bookingService + "calendar/entry/view/partner",
	getConservationBookings: bookingService + "bookings/guests/list",
	getConservationPartnerBookings:
		bookingService + "bookings/guests/partner/list",
	getVehicleBookings: bookingService + "bookings/vehicles/list",
	getVehiclePartnerBookings: bookingService + "bookings/vehicles/partner/list"
};

export const vehicleFeeUrls = {
	postVehicleFee: bookingService + "vehicle/charges/new",
	getVehicleFees: bookingService + "vehicle/charges/view",
	getVehicleFee: bookingService + "starts/single/",
	deleteVehicleFee: bookingService + "vehicle/charges/delete",
	editVehicleFee: bookingService + "vehicle/charges/edit",
	getAllVehicleFees: bookingService + "vehicle/charges/view",
	restoreVehicleFee: bookingService + "starts/restore/",
	getDeletedVehicleFee: bookingService + "starts/deleted"
};

export const destinationUrls = {
	postDestination: bookingService + "destination/new",
	getDestinations: bookingService + "destination/view",
	getDestination: bookingService + "starts/single/",
	deleteDestination: bookingService + "destination/delete",
	editDestination: bookingService + "destination/modify",
	getAllDestinations: bookingService + "destination/view",
	restoreDestination: bookingService + "starts/restore/",
	getDeletedDestination: bookingService + "starts/deleted"
};

export const driversUrls = {
  getAllDrivers: bookingService + "drivers/view",
  getDrivers: bookingService + "drivers/view/", 
  getDriver: bookingService + "drivers/view/", 
  getDeletedDrivers: null, 
  postDriver: bookingService + "drivers/new",
  editDriver: bookingService + "drivers/edit",
  deleteDriver: bookingService + "drivers/delete",
  restoreDriver: null, 
  updatePublicIds: bookingService + "drivers/update-public-ids"
};

export const autosUrls = {
  getAllAutos: bookingService + "autos/view",
  getAutos: bookingService + "autos/view/", 
  getAuto: bookingService + "autos/view/",
  getDeletedAutos: bookingService + "autos/deleted", 
  postAuto: bookingService + "autos/new",
  editAuto: bookingService + "autos/edit",
  deleteAuto: bookingService + "autos/delete",
  restoreAuto: bookingService + "autos/restore/" 
};



export const groupBookingTypeUrls = {
	postGroupBookingType: bookingService + "starts/post",
	getGroupBookingTypes: bookingService + "bookings/group/types/view",
	getGroupBookingType: bookingService + "starts/single/",
	deleteGroupBookingType: bookingService + "starts/delete/",
	editGroupBookingType: bookingService + "starts/edit/",
	getAllGroupBookingTypes: bookingService + "bookings/group/types/view",
	restoreGroupBookingType: bookingService + "starts/restore/",
	getDeletedGroupBookingType: bookingService + "starts/deleted"
};

export const gateUrls = {
	postGate: bookingService + "gates/new",
	getGates: bookingService + "gates/view",
	getGate: bookingService + "starts/single/",
	deleteGate: bookingService + "gates/delete",
	getUnticketedVehicles: bookingService + "unticketed/vehicles",
	editGate: bookingService + "gates/modify",
	getAllGates: bookingService + "gates/view",
	restoreGate: bookingService + "starts/restore/",
	getDeletedGate: bookingService + "starts/deleted",
	postEntryMode: bookingService + "entry_mode/new",
	getAllEntryModes: bookingService + "entry_mode/view",
	editEntryMode: bookingService + "entry_mode/modify",
	deleteEntryMode: bookingService + "entry_mode/delete",
	
};

export const PickUpLocationUrls = {
	postPickuplocation: bookingService + "pick-up/new",
	getAllPick_up_locations: bookingService + "pick-up/view",
	getPickuplocation: bookingService + "get_single",
	editPickuplocation: bookingService + "pick-up/modify",
	getDeletedPick_up_locations: bookingService + "delete",
	deletePickuplocation: bookingService + "pick-up/delete"
};

export const FacilityPricingTypeUrls = {
	postFacilitypricingtype: bookingService + "facility/pricing/new",
	getAllFacility_pricing_types: bookingService + "facility/pricing/view",
	getFacilitypricingtype: bookingService + "facility/pricing/view/",
	editFacilitypricingtype: bookingService + "facility/pricing/modify",
	getDeletedFacility_pricing_types: bookingService + "facility/pricing/delete",
	deleteFacilitypricingtype: bookingService + "facility/pricing/delete"
};

export const NoteUrls = {
	postNote: bookingService + "note/new",
	postRangerNote: bookingService + "inspection-note/new",
	postUnticketed: bookingService + "inspection-unticketed-note/new",
	updateRangerNote: bookingService + "inspection-note/update",
	updateUnticketedRangerNote: bookingService + "unticketed-inspection-note/update",
	updateRawAlert: bookingService + "unticketed-inspection-note/edit",
	getAllNotes: bookingService + "get_all",
	getNote: bookingService + "get_single",
	editNote: bookingService + "update",
	getDeletedNotes: bookingService + "delete",
	deleteNote: bookingService + "note/delete",
	getAlertedNote: bookingService + "note/view/inpected-alerted-note/",
};

export const CredentialUrls = {
	postCredential: bookingService + "salesforce/credentials",
	getAllCredentials: bookingService + "salesforce/users",
	pushVisitRecords: bookingService + "post/visits",
	getCredential: bookingService + "get_single",
	editCredential: bookingService + "update",
	getDeletedCredentials: bookingService + "delete",
	deleteCredential: bookingService + "delete"
};
export const bookingReportUrls = {
	generateBookingsRevenueData: bookingService + "bookings-revenue/chart",
	generateResidencyRevenueData: bookingService + "revenue/chart",
	getPaymentMethods: bookingService + "payments/methods/view",
	generateVehicleRevenueData: bookingService + "vehicle-revenue/chart",
	generateInventoryRevenueData: bookingService + "inventory/chart",
	generateTransactionsData: bookingService + "transactions/chart",
	
};

